const countries = [
  {
    code: 200,
    result: [
      { name: "ANDORRA", code: "AD", states: null },
      { name: "EMIRATOS ARABES UNIDOS", code: "AE", states: null },
      { name: "AFGHANISTAN", code: "AF", states: null },
      { name: "ANTIGUA Y BARBUDA", code: "AG", states: null },
      { name: "ANGUILLA", code: "AI", states: null },
      { name: "ALBANIA", code: "AL", states: null },
      { name: "ARMENIA", code: "AM", states: null },
      { name: "ANTILLAS HOLANDESAS", code: "AN", states: null },
      { name: "ANGOLA", code: "AO", states: null },
      { name: "ANTÁRTICA", code: "AQ", states: null },
      { name: "ARGENTINA", code: "AR", states: null },
      { name: "SSAMOA AMERICANA", code: "AS", states: null },
      { name: "AUSTRIA", code: "AT", states: null },
      {
        name: "AUSTRALIA",
        code: "AU",
        states: [
          { code: "ACT", name: "Australian Capital Territory" },
          { code: "NSW", name: "New South Wales" },
          { code: "NT", name: "Northern Territory" },
          { code: "QLD", name: "Queensland" },
          { code: "SA", name: "South Australia" },
          { code: "TAS", name: "Tasmania" },
          { code: "VIC", name: "Victoria" },
          { code: "WA", name: "Western Australia" },
        ],
      },
      { name: "ARUBA", code: "AW", states: null },
      { name: "AZERBAIJAN", code: "AZ", states: null },
      { name: "BOSNIA Y HERZEGOVINA", code: "BA", states: null },
      { name: "BARBADOS", code: "BB", states: null },
      { name: "BANGLADESH", code: "BD", states: null },
      { name: "BELGICA", code: "BE", states: null },
      { name: "BURKINA FASO", code: "BF", states: null },
      { name: "BULGARIA", code: "BG", states: null },
      { name: "BAHRAIN", code: "BH", states: null },
      { name: "BURUNDI", code: "BI", states: null },
      { name: "BENIN", code: "BJ", states: null },
      { name: "BERMUDA", code: "BM", states: null },
      { name: "BRUNEI DARUSSALEM", code: "BN", states: null },
      { name: "BOLIVIA", code: "BO", states: null },
      {
        name: "BRASIL",
        code: "BR",
        states: [
          { code: "AC", name: "Acre" },
          { code: "AL", name: "Alagoas" },
          { code: "AM", name: "Amazonas" },
          { code: "AP", name: "Amapá" },
          { code: "BA", name: "Bahia" },
          { code: "CE", name: "Ceará" },
          { code: "DF", name: "Distrito Federal" },
          { code: "ES", name: "Espírito Santo" },
          { code: "GO", name: "Goiás" },
          { code: "MA", name: "Maranhão" },
          { code: "MG", name: "Minas Gerais" },
          { code: "MS", name: "Mato Grosso do Sul" },
          { code: "MT", name: "Mato Grosso" },
          { code: "PA", name: "Pará" },
          { code: "PB", name: "Paraíba" },
          { code: "PE", name: "Pernambuco" },
          { code: "PI", name: "Piauí" },
          { code: "PR", name: "Paraná" },
          { code: "RJ", name: "Rio de Janeiro" },
          { code: "RN", name: "Rio Grande do Norte" },
          { code: "RO", name: "Rondônia" },
          { code: "RR", name: "Roraima" },
          { code: "RS", name: "Rio Grande do Sul" },
          { code: "SC", name: "Santa Catarina" },
          { code: "SE", name: "Sergipe" },
          { code: "SP", name: "São Paulo" },
          { code: "TO", name: "Tocantins" },
        ],
      },
      { name: "BAHAMAS", code: "BS", states: null },
      { name: "BHUTAN", code: "BT", states: null },
      { name: "ISLA BOUVET", code: "BV", states: null },
      { name: "BOTSWANA", code: "BW", states: null },
      { name: "BELARUS", code: "BY", states: null },
      { name: "BELIZE", code: "BZ", states: null },
      {
        name: "CANADÁ",
        code: "CA",
        states: [
          { code: "AB", name: "Alberta" },
          { code: "BC", name: "British Columbia" },
          { code: "MB", name: "Manitoba" },
          { code: "NB", name: "New Brunswick" },
          { code: "NL", name: "Newfoundland and Labrador" },
          { code: "NS", name: "Nova Scotia" },
          { code: "NT", name: "Northwest Territories" },
          { code: "NU", name: "Nunavut" },
          { code: "ON", name: "Ontario" },
          { code: "PE", name: "Prince Edward Island" },
          { code: "QC", name: "Quebec" },
          { code: "SK", name: "Saskatchewan" },
          { code: "YT", name: "Yukon" },
        ],
      },
      { name: "ISLAS COCOS(KEELING)", code: "CC", states: null },
      {
        name: "REPÚBLICA DEMOCRÁTICA DEL CONGO",
        code: "CD",
        states: null,
      },
      { name: "REPÚBLICA DE AFRICA CENTRAL", code: "CF", states: null },
      { name: "CONGO", code: "CG", states: null },
      { name: "SUIZA", code: "CH", states: null },
      { name: "COSATA DE MARFÍL", code: "CI", states: null },
      { name: "ISLAS COOK", code: "CK", states: null },
      { name: "CHILE", code: "CL", states: null },
      { name: "CAMERÚN", code: "CM", states: null },
      { name: "CHINA", code: "CN", states: null },
      { name: "COLOMBIA", code: "CO", states: null },
      { name: "COSTA RICA", code: "CR", states: null },
      { name: "REPÚBLICA DE CUBA", code: "CU", states: null },
      { name: "CABO VERDE", code: "CV", states: null },
      { name: "CURACAO", code: "CW", states: null },
      { name: "KIRITIMATI", code: "CX", states: null },
      { name: "CHIPRE", code: "CY", states: null },
      { name: "REPÚBLICA CHECA", code: "CZ", states: null },
      { name: "ALEMANIA", code: "DE", states: null },
      { name: "DJIBOUTI", code: "DJ", states: null },
      { name: "DINAMARCA", code: "DK", states: null },
      { name: "DOMINICA", code: "DM", states: null },
      { name: "REPÚBLICA DOMINICANA", code: "DO", states: null },
      { name: "ALGERIA", code: "DZ", states: null },
      { name: "ECUADOR", code: "EC", states: null },
      { name: "ESTONIA", code: "EE", states: null },
      { name: "EGIPTO", code: "EG", states: null },
      { name: "SAHARA DEL OESTE", code: "EH", states: null },
      { name: "ERITREA", code: "ER", states: null },
      { name: "ESPAÑA", code: "ES", states: null },
      { name: "ETIOPIA", code: "ET", states: null },
      { name: "FINLANDIA", code: "FI", states: null },
      { name: "FIJI", code: "FJ", states: null },
      { name: "ISLAS MALVINAS", code: "FK", states: null },
      { name: "ESTADOS FEDERADOS DE MICRONESIA", code: "FM", states: null },
      { name: "ISLAS FEROE", code: "FO", states: null },
      { name: "FRANCIA", code: "FR", states: null },
      { name: "GABÓN", code: "GA", states: null },
      { name: "REINO UNIDO", code: "GB", states: null },
      { name: "GRANADA", code: "GD", states: null },
      { name: "GEORGIA", code: "GE", states: null },
      { name: "GUINEA FRANCESA", code: "GF", states: null },
      { name: "GUERNESEY", code: "GG", states: null },
      { name: "GHANA", code: "GH", states: null },
      { name: "GIBRALTAR", code: "GI", states: null },
      { name: "GROENLANDIA", code: "GL", states: null },
      { name: "GAMBIA", code: "GM", states: null },
      { name: "GUINEA", code: "GN", states: null },
      { name: "GUADALUPE", code: "GP", states: null },
      { name: "GUINEA ECUATORIAL", code: "GQ", states: null },
      { name: "GRECIA", code: "GR", states: null },
      {
        name: "GEORGIA DEL SUR Y LAS ISLAS SANDWICH DEL SUR",
        code: "GS",
        states: null,
      },
      { name: "GUATEMALA", code: "GT", states: null },
      { name: "GUAM", code: "GU", states: null },
      { name: "GUINEA-BISSAU", code: "GW", states: null },
      { name: "GUYANA", code: "GY", states: null },
      { name: "HONK KONG", code: "HK", states: null },
      { name: "ISLAS HEARD Y MACDONALD", code: "HM", states: null },
      { name: "HONDURAS", code: "HN", states: null },
      { name: "CROACIA", code: "HR", states: null },
      { name: "HAITI", code: "HT", states: null },
      { name: "HUNGRIA", code: "HU", states: null },
      { name: "INDONESIA", code: "ID", states: null },
      { name: "IRLANDA", code: "IE", states: null },
      { name: "ISRAEL", code: "IL", states: null },
      { name: "ISLA DE MAN", code: "IM", states: null },
      { name: "INDIA", code: "IN", states: null },
      {
        name: "TERRITORIO BRITÁNICO DEL OCEANO ÍNDICO",
        code: "IO",
        states: null,
      },
      { name: "IRAQ", code: "IQ", states: null },
      { name: "REPUBLICA ISLÁMICA DE IRÁN", code: "IR", states: null },
      { name: "ISLANDIA", code: "IS", states: null },
      { name: "ITALIA", code: "IT", states: null },
      { name: "JERSEY", code: "JE", states: null },
      { name: "JAMAICA", code: "JM", states: null },
      { name: "JORDAN", code: "JO", states: null },
      {
        name: "JAPÓN",
        code: "JP",
        states: [
          { code: "01", name: "Hokkaido" },
          { code: "02", name: "Aomori" },
          { code: "03", name: "Iwate" },
          { code: "04", name: "Miyagi" },
          { code: "05", name: "Akita" },
          { code: "06", name: "Yamagata" },
          { code: "07", name: "Fukushima" },
          { code: "08", name: "Ibaraki" },
          { code: "09", name: "Tochigi" },
          { code: "10", name: "Gunma" },
          { code: "11", name: "Saitama" },
          { code: "12", name: "Chiba" },
          { code: "13", name: "Tokyo" },
          { code: "14", name: "Kanagawa" },
          { code: "15", name: "Niigata" },
          { code: "16", name: "Toyama" },
          { code: "17", name: "Ishikawa" },
          { code: "18", name: "Fukui" },
          { code: "19", name: "Yamanashi" },
          { code: "20", name: "Nagano" },
          { code: "21", name: "Gifu" },
          { code: "22", name: "Shizuoka" },
          { code: "23", name: "Aichi" },
          { code: "24", name: "Mie" },
          { code: "25", name: "Shiga" },
          { code: "26", name: "Kyoto" },
          { code: "27", name: "Osaka" },
          { code: "28", name: "Hyogo" },
          { code: "29", name: "Nara" },
          { code: "30", name: "Wakayama" },
          { code: "31", name: "Tottori" },
          { code: "32", name: "Shimane" },
          { code: "33", name: "Okayama" },
          { code: "34", name: "Hiroshima" },
          { code: "35", name: "Yamaguchi" },
          { code: "36", name: "Tokushima" },
          { code: "37", name: "Kagawa" },
          { code: "38", name: "Ehime" },
          { code: "39", name: "Kochi" },
          { code: "40", name: "Fukuoka" },
          { code: "41", name: "Saga" },
          { code: "42", name: "Nagasaki" },
          { code: "43", name: "Kumamoto" },
          { code: "44", name: "Oita" },
          { code: "45", name: "Miyazaki" },
          { code: "46", name: "Kagoshima" },
          { code: "47", name: "Okinawa" },
        ],
      },
      { name: "KENIA", code: "KE", states: null },
      { name: "KIRGISTAN", code: "KG", states: null },
      { name: "CAMBOYA", code: "KH", states: null },
      { name: "KIRIBATI", code: "KI", states: null },
      { name: "CCOMOROSomoros", code: "KM", states: null },
      { name: "SAN CRISTOBAL Y NIEVES", code: "KN", states: null },
      {
        name: "REPÚBLICA DEMOCRÁTICA Y POPULAR DE KOREA",
        code: "KP",
        states: null,
      },
      { name: "REPÚBLICA DE KOREA", code: "KR", states: null },
      { name: "KUWAIT", code: "KW", states: null },
      { name: "ISLAS CAIMÁN", code: "KY", states: null },
      { name: "KAZAGISTAN", code: "KZ", states: null },
      {
        name: "REPÚBLICA DEMOCRÁTICA Y POPULAR DE LAOS",
        code: "LA",
        states: null,
      },
      { name: "LEBANOS", code: "LB", states: null },
      { name: "SANTA LUCIA", code: "LC", states: null },
      { name: "LIECHTENSTEIN", code: "LI", states: null },
      { name: "SRI LANKA", code: "LK", states: null },
      { name: "LIBERIA", code: "LR", states: null },
      { name: "LESOTHO", code: "LS", states: null },
      { name: "LITUANIA", code: "LT", states: null },
      { name: "LUXEMBURGO", code: "LU", states: null },
      { name: "LETONIA", code: "LV", states: null },
      { name: "LIBIA", code: "LY", states: null },
      { name: "MARRUECOS", code: "MA", states: null },
      { name: "MONACO", code: "MC", states: null },
      { name: "REPÚBLICA DE MOLDOVA", code: "MD", states: null },
      { name: "MONTENEGRO", code: "ME", states: null },
      { name: "SAN MARTIN", code: "MF", states: null },
      { name: "MADAGASCAR", code: "MG", states: null },
      { name: "ISLAS MARSHALL", code: "MH", states: null },
      { name: "REPÚBLICA DE MACEDONIA DEL NORTE", code: "MK", states: null },
      { name: "MALI", code: "ML", states: null },
      { name: "MYANMAR", code: "MM", states: null },
      { name: "MONGOLIA", code: "MN", states: null },
      { name: "MACAO", code: "MO", states: null },
      { name: "ISLAS MARIANAS DEL NORTE", code: "MP", states: null },
      { name: "MARTINICA", code: "MQ", states: null },
      { name: "MAURITANIA", code: "MR", states: null },
      { name: "MONTSERRAT", code: "MS", states: null },
      { name: "MALTA", code: "MT", states: null },
      { name: "MAURITANIA", code: "MU", states: null },
      { name: "MALDIVAS", code: "MV", states: null },
      { name: "MALAWI", code: "MW", states: null },
      { name: "MÉXICO", code: "MX", states: null },
      { name: "MALASIA", code: "MY", states: null },
      { name: "MOZAMBIQUE", code: "MZ", states: null },
      { name: "NAMIBIA", code: "NA", states: null },
      { name: "NUEVA CELEDONIA", code: "NC", states: null },
      { name: "NIGER", code: "NE", states: null },
      { name: "ISLAS NORFOLK", code: "NF", states: null },
      { name: "NIGERIA", code: "NG", states: null },
      { name: "NICARAGUA", code: "NI", states: null },
      { name: "PAISES BAJOS", code: "NL", states: null },
      { name: "NORUEGA", code: "NO", states: null },
      { name: "NEPAL", code: "NP", states: null },
      { name: "NAURU", code: "NR", states: null },
      { name: "NIUE", code: "NU", states: null },
      { name: "NUEVA ZELANDA", code: "NZ", states: null },
      { name: "OMÁN", code: "OM", states: null },
      { name: "PANAMÁ", code: "PA", states: null },
      { name: "PERÚ", code: "PE", states: null },
      { name: "POLINESIA FRANCESA", code: "PF", states: null },
      { name: "PAPUA NUEVA GUINEA", code: "PG", states: null },
      { name: "FILIPINAS", code: "PH", states: null },
      { name: "PAKISTÁN", code: "PK", states: null },
      { name: "POLONIA", code: "PL", states: null },
      { name: "SAN PIERRE Y MIQUELON", code: "PM", states: null },
      { name: "ISLAS PITCAIRN", code: "PN", states: null },
      { name: "PUERTO RICO", code: "PR", states: null },
      { name: "TERRITORIO OCUPADO DE PALESTINA", code: "PS", states: null },
      { name: "PORTUGAL", code: "PT", states: null },
      { name: "PALAU", code: "PW", states: null },
      { name: "PARAGUAY", code: "PY", states: null },
      { name: "QATAR", code: "QA", states: null },
      { name: "REUNION", code: "RE", states: null },
      { name: "RUMANIA", code: "RO", states: null },
      { name: "SERBIA", code: "RS", states: null },
      { name: "FEDERACIÓN RUSA", code: "RU", states: null },
      { name: "RUANDA", code: "RW", states: null },
      { name: "ARABIA SAUDI", code: "SA", states: null },
      { name: "ISLAS SALOMON", code: "SB", states: null },
      { name: "SEYCHELLES", code: "SC", states: null },
      { name: "SUDÁN", code: "SD", states: null },
      { name: "SUECIA", code: "SE", states: null },
      { name: "SINGAPUR", code: "SG", states: null },
      { name: "SANTA HELENA", code: "SH", states: null },
      { name: "ESLOVENIA", code: "SI", states: null },
      { name: "SVALBARD Y JAN MAYEN", code: "SJ", states: null },
      { name: "ESLOVAQUIA", code: "SK", states: null },
      { name: "SIERRA LEONA", code: "SL", states: null },
      { name: "SAN MARINO", code: "SM", states: null },
      { name: "SENEGAL", code: "SN", states: null },
      { name: "SOMALIA", code: "SO", states: null },
      { name: "SURINAME", code: "SR", states: null },
      { name: "SANTO TOMÁS Y PRINCIPE", code: "ST", states: null },
      { name: "EL SALVADOR", code: "SV", states: null },
      { name: "SANTA MARTA", code: "SX", states: null },
      { name: "REPÚBLICA ÁRABE DE SIRIA", code: "SY", states: null },
      { name: "ESWATINI", code: "SZ", states: null },
      { name: "ISLAS DE TURKS Y CAICOS", code: "TC", states: null },
      { name: "CHAD", code: "TD", states: null },
      { name: "TERRITORIOS FRANCESES DEL SUR", code: "TF", states: null },
      { name: "TOGO", code: "TG", states: null },
      { name: "TAILANDIA", code: "TH", states: null },
      { name: "TAJIKISTAN", code: "TJ", states: null },
      { name: "TOKELAU", code: "TK", states: null },
      { name: "TIMOR-LESTE", code: "TL", states: null },
      { name: "TURKMENISTAN", code: "TM", states: null },
      { name: "TÚNEZ", code: "TN", states: null },
      { name: "TONGA", code: "TO", states: null },
      { name: "TURQUIA", code: "TR", states: null },
      { name: "TRINIDAD Y TOBAGO", code: "TT", states: null },
      { name: "TUVALU", code: "TV", states: null },
      { name: "TAIWAN", code: "TW", states: null },
      { name: "TANZANIA", code: "TZ", states: null },
      { name: "UCRANIA", code: "UA", states: null },
      { name: "UGANDA", code: "UG", states: null },
      // {
      //   name: "United States Minor Outlying Islands",
      //   code: "UM",
      //   states: null,
      // },
      {
        name: "ESTADOS UNIDOS",
        code: "US",
        states: [
          { code: "AA", name: "Armed Forces Americas (except Canada)" },
          { code: "AE", name: "Armed Forces" },
          { code: "AK", name: "Alaska" },
          { code: "AL", name: "Alabama" },
          { code: "AP", name: "Armed Forces Pacific" },
          { code: "AR", name: "Arkansas" },
          { code: "AS", name: "American Samoa" },
          { code: "AZ", name: "Arizona" },
          { code: "CA", name: "California" },
          { code: "CO", name: "Colorado" },
          { code: "CT", name: "Connecticut" },
          { code: "DC", name: "District of Columbia" },
          { code: "DE", name: "Delaware" },
          { code: "FL", name: "Florida" },
          { code: "FM", name: "Federated States of Micronesia" },
          { code: "GA", name: "Georgia" },
          { code: "GU", name: "Guam" },
          { code: "HI", name: "Hawaii" },
          { code: "IA", name: "Iowa" },
          { code: "ID", name: "Idaho" },
          { code: "IL", name: "Illinois" },
          { code: "IN", name: "Indiana" },
          { code: "KS", name: "Kansas" },
          { code: "KY", name: "Kentucky" },
          { code: "LA", name: "Louisiana" },
          { code: "MA", name: "Massachusetts" },
          { code: "MD", name: "Maryland" },
          { code: "ME", name: "Maine" },
          { code: "MH", name: "Marshall Islands" },
          { code: "MI", name: "Michigan" },
          { code: "MN", name: "Minnesota" },
          { code: "MO", name: "Missouri" },
          { code: "MP", name: "Northern Mariana Islands" },
          { code: "MS", name: "Mississippi" },
          { code: "MT", name: "Montana" },
          { code: "NC", name: "North Carolina" },
          { code: "ND", name: "North Dakota" },
          { code: "NE", name: "Nebraska" },
          { code: "NH", name: "New Hampshire" },
          { code: "NJ", name: "New Jersey" },
          { code: "NM", name: "New Mexico" },
          { code: "NV", name: "Nevada" },
          { code: "NY", name: "New York" },
          { code: "OH", name: "Ohio" },
          { code: "OK", name: "Oklahoma" },
          { code: "OR", name: "Oregon" },
          { code: "PA", name: "Pennsylvania" },
          { code: "PR", name: "Puerto Rico" },
          { code: "PW", name: "Palau" },
          { code: "RI", name: "Rhode Island" },
          { code: "SC", name: "South Carolina" },
          { code: "SD", name: "South Dakota" },
          { code: "TN", name: "Tennessee" },
          { code: "TX", name: "Texas" },
          { code: "UT", name: "Utah" },
          { code: "VA", name: "Virginia" },
          { code: "VI", name: "Virgin Islands" },
          { code: "VT", name: "Vermont" },
          { code: "WA", name: "Washington" },
          { code: "WI", name: "Wisconsin" },
          { code: "WV", name: "West Virginia" },
          { code: "WY", name: "Wyoming" },
        ],
      },
      { name: "URUGUAY", code: "UY", states: null },
      { name: "UZBEKISTAN", code: "UZ", states: null },
      { name: "CIUDAD DEL VATICANO", code: "VA", states: null },
      { name: "SAN VICENTE Y LAS GRANADINASs", code: "VC", states: null },
      { name: "VENEZUELA", code: "VE", states: null },
      { name: "ISLAS VIRGENES BRITÁNICAS", code: "VG", states: null },
      { name: "ISLAS VIRGENES DE ESTAOS UNIDOS", code: "VI", states: null },
      { name: "VIETNAM", code: "VN", states: null },
      { name: "VANUATU", code: "VU", states: null },
      { name: "WALLIS Y FUTUNA", code: "WF", states: null },
      { name: "SAMOA", code: "WS", states: null },
      { name: "KOSOVO", code: "XK", states: null },
      { name: "YEMEN", code: "YE", states: null },
      { name: "MAYOTE", code: "YT", states: null },
      { name: "SUDAFRICA", code: "ZA", states: null },
      { name: "ZAMBIA", code: "ZM", states: null },
      { name: "ZIMBABWE", code: "ZW", states: null },
    ],
    extra: [],
  },
];

export default countries;
